import React from 'react';

function AccessibilityIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50781 4.24512C2.32031 4.33887 2.22656 4.49512 2.22656 4.65137C2.22656 7.52637 3.41406 12.4326 8.03906 14.6514C8.13281 14.7139 8.28906 14.7139 8.38281 14.6514C13.0078 12.4639 14.1953 7.52637 14.2266 4.65137C14.2266 4.49512 14.1016 4.33887 13.9453 4.24512L8.22656 1.83887L2.50781 4.24512ZM14.5078 2.87012C15.1953 3.18262 15.7266 3.83887 15.7266 4.65137C15.6953 7.77637 14.4141 13.4326 9.03906 16.0264C8.50781 16.2764 7.91406 16.2764 7.38281 16.0264C2.00781 13.4326 0.726562 7.77637 0.726562 4.65137C0.695312 3.83887 1.22656 3.18262 1.91406 2.87012L7.78906 0.370117C7.91406 0.307617 8.07031 0.276367 8.22656 0.276367C8.35156 0.276367 8.50781 0.307617 8.63281 0.370117L14.5078 2.87012ZM11.7578 6.80762L7.75781 10.8076C7.44531 11.1201 6.97656 11.1201 6.69531 10.8076L4.69531 8.80762C4.38281 8.52637 4.38281 8.05762 4.69531 7.77637C4.97656 7.46387 5.44531 7.46387 5.75781 7.77637L7.22656 9.24512L10.6953 5.77637C10.9766 5.46387 11.4453 5.46387 11.7578 5.77637C12.0391 6.05762 12.0391 6.52637 11.7578 6.80762Z"
        fill="#667085"
      />
    </svg>
  );
}
export default AccessibilityIcon;
